(function(angular){
	'use strict';
	
	angular
		.module('additionalInvestmentSuccessModule')
		.controller('AdditionalInvestmentSuccess', [
			'$timeout',
			'APP_BASE_PATH',
			'CheckoutFactory',
			'ServiceLevelFactory',
			'STATIC_BASE_PATH',
			AdditionalInvestmentSuccessFunction
		]);
	
	function AdditionalInvestmentSuccessFunction(
		$timeout,
		APP_BASE_PATH,
		CheckoutFactory,
		ServiceLevelFactory,
		STATIC_BASE_PATH) {

		var success = this;
		success.showText = false;

		function getVideoUrl() {
			var videoUrl = STATIC_BASE_PATH;

			if(success.newServiceLevel === 'ADVANCED') {
				videoUrl = videoUrl + '/video/advanced-upgrade-complete.mp4';
			} else if(success.newServiceLevel === 'CORE') {
				videoUrl = videoUrl + '/video/core-upgrade-complete.mp4';
			} else if(success.newServiceLevel === 'PREMIUM') {
				videoUrl = videoUrl + '/video/premium-upgrade-complete.mp4';
			}

			return videoUrl;
		}

		function showTextOnDelay() {
			$timeout(function() {
				success.showText = true;
			}, 2000);
		}

		success.$onInit = function() {
			angular.extend(success, globalConfig);
			
			success.transactionsUrl = APP_BASE_PATH + '/account/transactions';
			success.videoUrl = getVideoUrl();

			if(angular.isDefined(success.orderGroupId)) {
				CheckoutFactory.getOrderGroup(success.orderGroupId)
					.then(function(orderGroup) {
						success.orderGroup = orderGroup;
						success.newServiceLevel = success.orderGroup.serviceLevelUpgrade;
						success.loaded = true;
						
						if(success.newServiceLevel) {
							success.videoUrl = getVideoUrl();
							showTextOnDelay();
						} else {
							success.showText = true;
						}
					});
			} else {
				success.loaded = true;
				showTextOnDelay();
			}
		};
	}
})(window.angular);